import markApplications from "./markApplications";

const markApplicationService = [{
    matcher: 'cropMarkApplication',
    reply: config => {
        return [200, markApplications]
    }
},{
    matcher: /cropMarkApplication\/(.*)/,
    reply: config => {
        const id = /cropMarkApplication\/(.*)/.exec(config.url)[1];
        const data = markApplications.find(app => app.id === id);
        return [200, data];
    }
}]

export default markApplicationService;